import { StoreFeaturesProps } from "@omni/types/components/props/storeFeatures.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { StoreFeaturesContextProvider } from "./context/storeFeatures.context";

const Base = ({
    children,
    storeFeatures
}: RequireChildrenFor<StoreFeaturesProps>) => {
    return (
        <StoreFeaturesContextProvider storeFeatures={storeFeatures}>
            {children}
        </StoreFeaturesContextProvider>
    );
};

export { Base };
